import { ModalContent, ModalHeader } from 'semantic-ui-react';
import React, { useEffect, useState } from 'react';
import CopyToClipBoardv2 from 'app/components/CopyToClipboard/index';
import constants from 'app/constants/global-constants';
import { getToolsLaunchUrl } from '../helper';
var ToolsLaunchModal = function (_a) {
    var sandbox = _a.sandbox;
    var _b = useState(5), timer = _b[0], setTimer = _b[1];
    useEffect(function () {
        if (timer === 0) {
            window.open(getToolsLaunchUrl(sandbox), '_blank');
            return;
        }
        setTimeout(function () { return setTimer(timer - 1); }, 1000);
    }, [timer]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, null, "Opening with Neo4j Tools"),
        React.createElement(ModalContent, null,
            React.createElement("div", { className: "mb2" },
                "Tools will open in ",
                timer,
                " secs... to open now."),
            React.createElement("div", { className: "mb4" },
                "If Tools does not open, then either enable \"Popups\" from your browser settings or click",
                ' ',
                React.createElement("a", { href: getToolsLaunchUrl(sandbox), target: "_blank", rel: "noreferrer" }, "here"),
                ' '),
            React.createElement("div", null,
                React.createElement("div", { style: { fontWeight: 600, textDecoration: 'underline' }, className: "mb2" }, "Credentials"),
                React.createElement("span", { style: { fontWeight: 600 } }, "Server Address: "),
                React.createElement(CopyToClipBoardv2, null, "bolt+s://".concat(sandbox.sandboxHashKey, ".").concat(constants.SANDBOX_BOLT_DOMAIN, ":443")),
                React.createElement("br", null),
                React.createElement("span", { style: { fontWeight: 600 } }, "username: "),
                React.createElement(CopyToClipBoardv2, null, sandbox.username || 'neo4j'),
                React.createElement("br", null),
                React.createElement("span", { style: { fontWeight: 600 } }, "password: "),
                React.createElement(CopyToClipBoardv2, null, sandbox.password || 'letmein')))));
};
export default ToolsLaunchModal;
